import { getRedirectingPartnerName } from '@insify/funnel-components';
import { useOnFirstMount } from '@insify/react-hooks';
import { useTranslation } from 'react-i18next';
import { Navigate, Route, Routes } from 'react-router-dom';

import { FunnelLayout } from './components/FunnelLayout';
import { useCoBranding } from './hooks/useCoBranding';
import { useCommands } from './hooks/useCommands';

import type { Commands } from './models/commands';

export const Funnel = () => {
  const { sendMultipleCommands } = useCommands();
  const { partnerName } = useCoBranding();
  const { i18n } = useTranslation();

  useOnFirstMount(() => {
    const { redirectingPartnerName } = getRedirectingPartnerName();
    const commands: Commands[] = [];

    if (partnerName !== undefined) {
      const externalCustomerId = new URLSearchParams(window.location.search).get('customer_id');
      commands.push({
        type: 'usePartner',
        payload: {
          partner: partnerName,
          ...(externalCustomerId && { externalCustomerId }),
        },
      });
    }

    if (redirectingPartnerName !== undefined) {
      commands.push({
        type: 'useRedirectingPartner',
        payload: {
          partner: redirectingPartnerName,
        },
      });
    }

    void sendMultipleCommands(commands);
  });

  return (
    <Routes>
      <Route path='*' element={<Navigate to={i18n.language} />} />
      <Route path={`${i18n.language}/*`} element={<FunnelLayout />} />
    </Routes>
  );
};
